<template>
  <div class="map" ref="map-root"></div>
</template>

<script>
import Setup from '@/mixins/Setup.js'
import View from 'ol/View'
import Map from 'ol/Map'
import * as olInteraction from 'ol/interaction'
import * as olProj from 'ol/proj'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import getLanCoastLine from '@/store/Lan.js'
import { Stroke, Style } from 'ol/style'
import DataLayer from '@/store/SingleSpeciesDataLayer'

import 'ol/ol.css'

export default {
  name: 'MapContainer',
  components: {},
  mixins: [],
  props: {
    species: { type: Object, required: true }
  },
  data() {
    return {
      olMap: null
    }
  },
  mounted() {
    this.olMap = new Map({
      target: this.$refs['map-root'],
      controls: [],
      renderer: 'dom',
      interactions: olInteraction.defaults({
        mouseWheelZoom: false,
        dragPan: false
      }),
      layers: [
        new TileLayer({
          source: new OSM(),
          crossOrigin: null
        })
      ],

      // the map view will initially show Sweden
      view: new View({
        zoom: 4,
        center: olProj.fromLonLat([14, 63]),
        constrainResolution: true
      })
    })
    this.setup()
  },
  methods: {
    async setup() {
      try {
        // This request gets cached by Workbox
        let data = await DataLayer.GetSpecLanInfo()
        data = data.filter(row => row.spec_id === this.species.id)
        data.forEach(lan => {
          this.drawCoastLine(lan.lans_code)
        })
      } catch (e) {
        console.log(e)
      }
    },
    //Draws coastLine in Län
    drawCoastLine(lanId) {
      const coordinates = getLanCoastLine(lanId)

      const data = {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'MultiLineString',
          coordinates: [coordinates]
        }
      }
      const feature = new GeoJSON().readFeature(data, {
        featureProjection: 'EPSG:3857'
      })

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [feature]
        }),
        style: new Style({
          stroke: new Stroke({
            color: 'rgba(33, 162, 97, 0.8)',
            width: 3.5
          })
        })
      })
      this.olMap.addLayer(vectorLayer)
    }
  }
}
</script>

<style lang="css" scoped>
.map {
  width: 100%;
  height: 400px;
}
</style>
